import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/");
      return;
    }
    const sessionId = match[1];
    // Clear hash
    window.history.replaceState(null, "", window.location.pathname);

    (async () => {
      try {
        let deviceId = localStorage.getItem("nx_device_id");
        if (!deviceId) {
          deviceId = (crypto?.randomUUID?.() || Math.random().toString(36).slice(2) + Date.now().toString(36));
          localStorage.setItem("nx_device_id", deviceId);
        }
        const { data } = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId, "X-Device-Id": deviceId },
        });
        setUser(data.user);
        nav("/dashboard", { state: { user: data.user } });
      } catch (err) {
        const msg = err?.response?.data?.detail || "Errore autenticazione";
        alert(msg);
        nav("/");
      }
    })();
  }, [location, nav, setUser]);

  return (
    <div className="grid min-h-screen place-items-center text-slate-100">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-10 w-10 animate-spin text-cyan-300" />
        <p className="text-slate-300">Autenticazione in corso...</p>
      </div>
    </div>
  );
}
